const VLOGIN='VLOGIN';
const LOGIN_OUT='LOGIN_OUT'

export {
  VLOGIN,
  LOGIN_OUT
}



// WEBPACK FOOTER //
// ./src/store/mutation-type.js